import React, { useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useAlert } from '../../contexts/AlertContext';
import { useTranslation } from 'react-i18next';
import { handleDownload } from "../../utils/commonMethods";

interface Tool {
    hulpmiddel_link: string;
    hulpmiddel_name: string;
    hulpmiddel_path: string | null;
}

interface HulpmiddelListProps {
    data: Tool[];
    loader?: (loading: boolean) => void;
}

const HulpmiddelList: React.FC<HulpmiddelListProps> = ({ data, loader }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { showAlert } = useAlert();
    const [isLoading, setIsLoading] = useState(true);

    return (
        <Box>
            {data && data?.length > 0 ? (
                <Typography component="span">
                    {data.map((item, index) => (
                        <React.Fragment key={index}>
                            <Typography
                                fontFamily={"Nunito Sans Regular700"}
                                fontSize={"14px"}
                                component="span"
                                sx={{
                                    cursor: "pointer",
                                    color: theme.palette.secondary.main,
                                    display: "inline-flex",
                                    alignItems: "center",
                                }}
                                onClick={() => handleDownload(item?.hulpmiddel_path ?? '', 'Hulpmiddel', showAlert, t, setIsLoading)}
                            >
                                {item?.hulpmiddel_name}
                            </Typography>
                            {index !== data.length - 1 && (
                                <Typography
                                    variant="body2"
                                    component="span"
                                    sx={{ color: theme.palette.secondary.main }}
                                >
                                    {", "}{" "}
                                </Typography>
                            )}
                        </React.Fragment>
                    ))}
                </Typography>
            ) : (
                <Typography>{""}</Typography>
            )}
        </Box>
    );
};

export default HulpmiddelList;
